import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}

const addEssControlFlagMid = (tokens: any, flag: any, mids: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.addMid),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      settlementFlag: flag,
      entityIds: mids?.length > 0 ? mids?.join(',') : undefined,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { addEssControlFlagMid }
